//import Locations from '../components/locations.svelte'
import map from '../components/map.svelte'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		let $mapWrap = $('#locations_wrap')

		if ($mapWrap.length) {
			new map({
				target: $mapWrap[0],
				props: $mapWrap.data(),
			})
		}

		window.onload = adjustContentMargin
		window.onresize = adjustContentMargin
		function adjustContentMargin() {
			let $content = $('#locations_wrap')
			let $nav = $('.navbar-wrap')[0]
			$content.css('margin-top', $nav.getBoundingClientRect().height)
		}
	},
	finalize() {
		let tl = gsap.timeline() //new TweenMax({})//outdates
		// let tlm = new TweenMax({})
		tl.to('#locations_wrap', {
			opacity: 1,
			delay: 0.5,
			duration: 0.5,
			ease: 'expo.easeOut',
		})
		gsap.to('.main-content-wrap .textual', {
			opacity: 1,
			duration: 1,
			ease: 'expo.easeOut',
		})
		// tl.to('.contact-side-header', {
		// 	opacity: 1,
		// 	duration: 1,
		// 	ease: 'expo.easeOut',
		// })
		gsap.to('.contact-form-wrap', {
			opacity: 1,
			duration: 1,
			ease: 'expo.easeOut',
		})

		// gsap.fromTo(
		// 	'.gfield',
		// 	{
		// 		y: 10,
		// 		opacity: 0,
		// 	},
		// 	{
		// 		scrollTrigger: {
		// 			trigger: '.gfield',
		// 			// toggleActions: 'restart none restart pause',
		// 			// start: "+=50",
		// 			// end:"+=700",
		// 			// scrub: true
		// 		},
		// 		opacity: 1,
		// 		y: 0,
		// 		delay: 2,
		// 		duration: 1,
		// 		stagger: 0.2,
		// 		ease: 'expo.easeOut',
		// 	}
		// )
		// gsap.fromTo(
		// 	'#gform_submit_button_1',
		// 	{
		// 		y: 10,
		// 		opacity: 0,
		// 	},
		// 	{
		// 		scrollTrigger: {
		// 			trigger: '#gform_submit_button_1',
		// 			// toggleActions: 'restart none restart pause',
		// 			// start: "+=50",
		// 			// end:"+=700",
		// 			// scrub: true
		// 		},
		// 		opacity: 1,
		// 		y: 0,
		// 		delay: 2.75,
		// 		duration: 1,
		// 		stagger: 0.2,
		// 		ease: 'expo.easeOut',
		// 	}
		// )
		// gsap.to() //submits
		tl.fromTo(
			'.contact-side-content > *',
			{ y: 30 },
			{ y: 0, opacity: 1, duration: 0.35, ease: 'expo.easeOut', stagger: 0.25 }
		)
		// tl.fromTo('.side-phone',{y:30},{y:0,opacity:1,duration:0.35,ease:"expo.easeOut"})
		// tl.fromTo('.side-email',{y:30},{y:0,opacity:1,duration:0.35,ease:"expo.easeOut"})
	},
}
